export default __webpack_public_path__ + "static/sandbox-license-2ae7705ddf66c49450749243b0ba6386.png";